import { HookDefinition } from "@modules/sdk/hooks/HookDefinition";

export interface CartAddItemHookInput {
    readonly items: {
        readonly variantID: number;
        readonly quantity: number;
        readonly properties?: Record<string, string>;
    }[];
}

export interface CartAddItemHookResult {
    readonly items: {
        readonly variantID: number;
        readonly quantity: number;
        readonly properties?: Record<string, string>;
    }[];
}

const CART_ADD_ITEM = "cart.addItem";

const CartAddItemHookDefinition: HookDefinition<
    CartAddItemHookInput,
    CartAddItemHookResult
> = {
    name: CART_ADD_ITEM,
    defaultHandler: (
        input: CartAddItemHookInput
    ): Promise<CartAddItemHookResult> => {
        return Promise.resolve({
            items: input.items.map((item) => ({
                variantID: item.variantID,
                quantity: item.quantity,
                ...(item.properties && { properties: item.properties }),
            })),
        });
    },
};

export const CartHooksDefinitions = {
    ADD_ITEM: CartAddItemHookDefinition,
} as const;
